"use client"

import { useState } from "react"
import AbacusDisplay from "./AbacusDisplay"

const SelectingFruits = ({ onScore }) => {
  const [selections, setSelections] = useState({})

  const rows = [
    {
      abacusLeft: 3,
      fruits: [
        { type: "🍐", number: 3 },
        { type: "🍐", number: 1 },
      ],
      abacusRight: 1,
    },
    {
      abacusLeft: 7,
      fruits: [
        { type: "🍑", number: 7 },
        { type: "🍑", number: 8 },
      ],
      abacusRight: 8,
    },
    {
      abacusLeft: 4,
      fruits: [
        { type: "🍊", number: 4 },
        { type: "🍊", number: 2 },
      ],
      abacusRight: 2,
    },
    {
      abacusLeft: 9,
      fruits: [
        { type: "🍏", number: 9 },
        { type: "🍏", number: 5 },
      ],
      abacusRight: 5,
    },
    {
      abacusLeft: 6,
      fruits: [
        { type: "🍋", number: 6 },
        { type: "🍋", number: 0 },
      ],
      abacusRight: 0,
    },
  ]

  const selectFruit = (rowIndex, side, fruitIndex) => {
    const key = `${rowIndex}-${side}`
    const newSelections = { ...selections, [key]: fruitIndex.toString() }
    setSelections(newSelections)

    const row = rows[rowIndex]
    const targetValue = side === "left" ? row.abacusLeft : row.abacusRight
    const selectedFruit = row.fruits[fruitIndex]

    if (selectedFruit.number === targetValue) {
      onScore(15)
    }
  }

  return (
    <div className="lesson-card card-lime">
      <h2 className="lesson-title" style={{ color: "#365314" }}>
        Подбираем фрукты 🍎
      </h2>

      <p style={{ fontSize: "1.25rem", textAlign: "center", marginBottom: "24px" }}>
        Соедини абакус с правильным фруктом!
      </p>

      <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
        {rows.map((row, rowIndex) => (
          <div
            key={rowIndex}
            style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "16px", alignItems: "center" }}
          >
            {/* Левый абакус */}
            <div style={{ display: "flex", justifyContent: "center" }}>
              <div style={{ transform: "scale(0.7)" }}>
                <AbacusDisplay value={row.abacusLeft} />
              </div>
            </div>

            {/* Левый фрукт */}
            <div style={{ textAlign: "center" }}>
              <button
                onClick={() => selectFruit(rowIndex, "left", 0)}
                style={{
                  fontSize: "2.5rem",
                  padding: "16px",
                  borderRadius: "8px",
                  border: "2px solid",
                  backgroundColor: selections[`${rowIndex}-left`] === "0" ? "#bbf7d0" : "white",
                  borderColor: selections[`${rowIndex}-left`] === "0" ? "#22c55e" : "#e5e7eb",
                  cursor: "pointer",
                }}
              >
                {row.fruits[0].type}
                <div style={{ fontSize: "1.125rem", fontWeight: "bold" }}>{row.fruits[0].number}</div>
              </button>
            </div>

            {/* Правый фрукт */}
            <div style={{ textAlign: "center" }}>
              <button
                onClick={() => selectFruit(rowIndex, "right", 1)}
                style={{
                  fontSize: "2.5rem",
                  padding: "16px",
                  borderRadius: "8px",
                  border: "2px solid",
                  backgroundColor: selections[`${rowIndex}-right`] === "1" ? "#bbf7d0" : "white",
                  borderColor: selections[`${rowIndex}-right`] === "1" ? "#22c55e" : "#e5e7eb",
                  cursor: "pointer",
                }}
              >
                {row.fruits[1].type}
                <div style={{ fontSize: "1.125rem", fontWeight: "bold" }}>{row.fruits[1].number}</div>
              </button>
            </div>

            {/* Правый абакус */}
            <div style={{ display: "flex", justifyContent: "center" }}>
              <div style={{ transform: "scale(0.7)" }}>
                <AbacusDisplay value={row.abacusRight} />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default SelectingFruits
